import { FormularioTextosAdmin }      from "./FormularioTextosAdmin";
import { FormularioConstantesAdmin }  from "./FormularioConstantesAdmin";
import { FormularioIndicadoresAdmin } from "./FormularioIndicadoresAdmin";
import { FormularioPDFAdmin } from "./FormularioPDFAdmin";

export default function FormularioAdmin({ vista }) {
    if (vista === 'textos')      return <FormularioTextosAdmin />;
    if (vista === 'constantes')  return <FormularioConstantesAdmin />;
    if (vista === 'indicadores') return <FormularioIndicadoresAdmin />;
    if (vista === 'pdf')         return <FormularioPDFAdmin />;
    // fallback por si vista no está definida aún
    return <FormularioConstantesAdmin />;
}